// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","footerLinks":"A8hXA","footerLinkItem":"_1Rn-3","footerLink":"_3UCjG"};